import { useEffect, useState } from 'react'
import { EventType } from '../common/models'
import { StoreEventsStream } from '../common/flowevents'

export const useEventStream = storeId => {
  const [messages, setMessages] = useState([])
  const [callbacks, setCallbacks] = useState([])

  const handleEvent = ({ type, object, id }) => {
    const eventId = [id, object.created, object.type].join('_')
    switch (type) {
      case EventType.HEARTBEAT:
        break
      case EventType.ERROR:
        console.debug('Error', type, object)
        break
      case EventType.SMS:
        if (!messages.some(m => m.eventId === eventId)) {
          setMessages(current => [{ ...object, eventId }, ...current])
        }
        break
      case EventType.CALLBACK:
        if (!callbacks.some(m => m.eventId === eventId)) {
          setCallbacks(current => [
            {
              ...object,
              eventId,
              id: object.applicationId || object.paymentId,
              status: object.status || object.action,
            },
            ...current,
          ])
        }
        break
      default:
    }
  }

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (storeId) {
      const flowEvent = new StoreEventsStream(
        process.env.REACT_APP_TEST_HELPER_PATH,
        storeId,
      )
        .onMessage(event => {
          handleEvent(event)
        })
        .onError(event => console.log(`ERROR!: ${JSON.stringify(event)}`))

      window.addEventListener('beforeunload', () => {
        flowEvent?.close()
      })
      return () => flowEvent?.close()
    }
  }, [storeId])

  return [messages, callbacks]
}
